import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import * as classes from "./Card.module.scss";

export default function Card({className, use: ContainerComponent = "section", ...props}) {
    return (
        <ContainerComponent
            className={classNames(classes.container, className)}
            {...props} />
    );
}

Card.propTypes = {
    className: PropTypes.string,
    use: PropTypes.elementType
};
